import { defineStore } from "pinia";
import { ref, onMounted, watchEffect } from "vue";
import { access_token, getuserinfo } from "@/api/index";
import { ElMessage, ElMessageBox } from "element-plus";
import { getToken, setToken, getRefreshToken, setRefreshToken, removeTokens, setCode, getCode } from "@/utils/auth";
export const useUserStore = defineStore("user", () => {
  // 存储状态
  const accessToken = ref(getToken());
  const refreshToken = ref(getRefreshToken() || "");
  const userInfo = ref(null);
  const isRefreshing = ref(false); // 刷新状态
  const expiresIn = ref(0); // Token 过期时间（秒）
  // 1. 获取 Token（通过 code）
  async function login(code) {
    
    try {
      const response = await access_token({
        client_id: process.env.VUE_APP_CLIENT_ID,
        redirect_uri: process.env.VUE_APP_REDIRECT_URI,
        client_secret: process.env.VUE_APP_CLIENT_SECRET,
        grant_type: "authorization_code",
        code,
      });
      if (response.data.error_code) {
        // setCode(code);
        // setToken(response.data.access_token); // 保存到 Cookie
        // return;
        return
      //  return  window.location.href = "http://47.250.182.165:6002/sso/oauth2/authorize?client_id=50180484&redirect_uri=http://192.168.110.13:8870/dashboard&response_type=code&scope=baseinfo&state=abc";
      }
      setCode(code);
      setToken(response.data.access_token); // 保存到 Cookie
      setRefreshToken(response.data.refresh_token);
      expiresIn.value = response.data.expires_in;
      accessToken.value = response.data.access_token;
      refreshToken.value = response.data.refresh_token;
      await fetchUserInfo();
      return response.data;
    } catch (error) {
      console.error("登录失败:", error);
      throw error;
    }
  }
  // 2. 刷新 Token
  async function refreshTokenApi() {
    if (!refreshToken.value) return;
    isRefreshing.value = true;

    try {
      const response = await access_token({
        client_id: process.env.VUE_APP_CLIENT_ID,
        redirect_uri: process.env.VUE_APP_REDIRECT_URI,
        client_secret: process.env.VUE_APP_CLIENT_SECRET,
        grant_type: "refresh_token",
        refresh_token: refreshToken.value,
        code: getCode(),
      });
      if (response.data.error_code) {
        removeTokens();
        window.location.href = "http://127.0.0.1:10001/sso/oauth2/authorize?client_id=61947619&redirect_uri=http://192.168.110.13:8081/dashboard&response_type=code&scope=baseinfo&state=abc";
      }
      setToken(response.data.access_token);
      setRefreshToken(response.data.refresh_token);
      expiresIn.value = response.data.expires_in;
      accessToken.value = response.data.access_token;
      await fetchUserInfo();
      return response.data;
    } catch (error) {
      console.error("刷新 Token 失败:", error);
      removeTokens(); // 清除所有 Token
      throw error;
    } finally {
      isRefreshing.value = false;
    }
  }
  // 3. 获取用户信息
  async function fetchUserInfo() {
    if (!accessToken.value) return;
    try {
      const response = await getuserinfo({ access_token: accessToken.value });
      userInfo.value = response.data.data;
      if (response.data.error_code !== 1) {
        removeTokens();
        login()
      }
      return response.data;
    } catch (error) {
      console.error("获取用户信息失败:", error);
      throw error;
    }
  }
  // 4. 自动刷新逻辑（动态计算）
  let autoRefreshTimer = null;

  function calculateRefreshDelay() {
    if (!expiresIn.value) return 0;
    const now = Date.now() - new Date().getTimezoneOffset() * 60000;
    const remaining = expiresIn.value * 1000 - (now % (24 * 60 * 60 * 1000));
    return Math.max(remaining, 60 * 60 * 1000); // 至少1分钟
  }

  function startAutoRefresh() {
    if (!refreshToken.value || expiresIn.value <= 0) return;
    const delay = calculateRefreshDelay();
    autoRefreshTimer = setTimeout(() => refreshTokenApi(), delay);
  }

  // 初始化自动刷新
  onMounted(() => {
    startAutoRefresh();
  });

  // 监听 Token 变化
  watchEffect(() => {
    if (accessToken.value) {
      startAutoRefresh();
    } else {
      clearTimeout(autoRefreshTimer);
    }
  });
  // 登出操作
  function logout() {
    removeTokens(); // 清除 Cookie
    userInfo.value = null;
    expiresIn.value = 0;
    clearTimeout(autoRefreshTimer);
  }
  return {
    accessToken,
    refreshToken,
    userInfo,
    isRefreshing,
    login,
    refreshTokenApi,
    fetchUserInfo,
    logout,
    startAutoRefresh,
  };
});
